module.exports = __webpack_public_path__ + "static/media/vertical_dots.dd7693cf.svg";